export const DOCUMENTS_ENDPOINT = `https://${process.env.NEXT_PUBLIC_DOCUMENTS_SERVICE_DOMAIN_NAME}`;
